import { render, staticRenderFns } from "./AthleteAccepted.vue?vue&type=template&id=4b3aca1c&"
import script from "./AthleteAccepted.vue?vue&type=script&lang=js&"
export * from "./AthleteAccepted.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports